import {StoppageGroup, RcfaStoppageKind as StoppageKind} from '@domain/shared'

import {StoppageInfo} from '../types'

import {StoppageGroupDetail} from './StoppageGroupDetail'

export const StoppageContent = ({
  stoppage,
  translationNamespace
}: {
  stoppage?: StoppageInfo
  translationNamespace?: string
}) => {
  const filteredGroupStoppages: StoppageGroup[] = (stoppage?.groupStoppages ?? []).filter(
    (kind) =>
      kind.stoppageKind === StoppageKind.Incident || kind.stoppageKind === StoppageKind.Circumstance
  )

  return stoppage ? (
    <>
      <StoppageGroupDetail
        code={stoppage?.stoppageCode}
        start={stoppage.start}
        end={stoppage.end}
        duration={stoppage.duration}
        dataTestId={'stoppage-details'}
        translationNamespace={translationNamespace}
      />

      {filteredGroupStoppages.map(({code, start, end, duration}) => (
        <StoppageGroupDetail
          code={code}
          start={start}
          end={end}
          duration={duration}
          key={`stoppage-code-${code?.code}`}
          dataTestId={'stoppageGroup-details'}
          translationNamespace={translationNamespace}
        />
      ))}
    </>
  ) : (
    <></>
  )
}
